import { AnyFunction } from '../types/AnyFunction';

export function executeFunction<Fn extends AnyFunction>(fn?: Fn, ...fnArgs: Parameters<Fn>): void {
  if (typeof fn === 'function') {
    fn(...fnArgs);
  }
}
